var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 52",
    d: "M8.12182 2.03125H1.84851C1.62363 2.03175 1.4081 2.12131 1.24908 2.28033C1.09006 2.43935 1.0005 2.65488 1 2.87977V9.15307C1.0005 9.37796 1.09006 9.59349 1.24908 9.75251C1.4081 9.91153 1.62363 10.0011 1.84851 10.0016H8.12182C8.34671 10.0011 8.56224 9.91153 8.72126 9.75251C8.88028 9.59349 8.96983 9.37796 8.97034 9.15307V2.87977C8.96983 2.65488 8.88028 2.43935 8.72126 2.28033C8.56224 2.12131 8.34671 2.03175 8.12182 2.03125Z",
    stroke: "#0A7F8F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 25",
    d: "M2.70605 4.83203H4.72724",
    stroke: "#0A7F8F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 26",
    d: "M2.70605 6.57812H7.08211",
    stroke: "#0A7F8F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 27",
    d: "M3.75586 1V2.86864",
    stroke: "#0A7F8F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 28",
    d: "M6.21484 1V2.86864",
    stroke: "#0A7F8F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderActive);
export default __webpack_public_path__ + "static/media/calender_active.a9838a035df40c92c039972ed2aa8bbb.svg";
export { ForwardRef as ReactComponent };